"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelectObject = void 0;
// pass some object that exists as runtime and get back a typesafe object
// with the same keys but with true as value (ie. pass enum of PublicUser
// fields and get back a select object for prisma for those fields)
function createSelectObject(obj) {
    const keys = Object.keys(obj);
    const selectObject = {};
    keys.forEach((key) => {
        selectObject[key] = true;
    });
    return selectObject;
}
exports.createSelectObject = createSelectObject;
//# sourceMappingURL=createSelectObject.js.map